diy.angular.registerFactory('diyfmsourcekeyvisuals', ['$q', '$injector', '$http', 'diyl10n', 'diyfmsectionmodel', 'diyfmsubsectionmodel', 'diyfmconstkeyvisual', 'diyinfo', 'diyfmconfig',
function($q, $injector, $http, diyl10n, diyfmsectionmodel, diyfmsubsectionmodel, diyfmconstkeyvisual, diyinfo, diyfmconfig) {
    var 
        source = {},
        section,
        itemsProvider = {}
    ;
    
    var getName = function() {
        return 'keyvisuals';
    };

    var getSectionModel = function() {
        return $injector.get('diyfmsectioncompany');
    };
    
    itemsProvider.queryRange = function(params, offset, limit) {
        params = params || {};
        var defer = $q.defer();
        var url = '/app/module/emotionheader/searchimages?justImages=1';
        
        // XXX server side don't support search inside a topic, it emulates 
        // topic filter using search param with topic name
        if (params.topicName) {
            url += (params.topicName ? '&query=' + encodeURIComponent(params.topicName) : '');
        } else {
            url += (params.search ? '&query=' + encodeURIComponent(params.search) : '');
        }
        url += (offset !== undefined ? '&offset=' + encodeURIComponent(offset) : '');
        url += (limit !== undefined ? '&limit=' + encodeURIComponent(limit) : '');
        
        var 
            thumbSize = diyfmconfig.getThumbSize(),
            previewSize = diyfmconfig.getPreviewSize()
        ;
        
        url += '&thumbWidth=' + thumbSize.width;
        url += '&thumbHeight=' + thumbSize.height;
        url += '&previewWidth=' + previewSize.width;
        url += '&previewHeight=' + previewSize.height;
        
        $http.get(url)
            .success(function(data, status, headers, config) {
                if (data.data) {
                    defer.resolve({items: data.data, totalCount: data.totalCount});
                    currentPage = 1;
                } else {
                    diyfmmessages.handleGenericError();
                }
            }).error(function(data, status, headers, config) {
                diyfmmessages.handleGenericError();
                defer.reject();
            });
        return defer.promise;
    };
    
    var getItemsProvider = function() {
        return itemsProvider;
    };
    
    var toolbarItems = [
        ' ', // spacer
        'search'
    ];
    
    var getToolbarItems = function(subsection) {
        return toolbarItems; 
    };
    
    return angular.extend(source, {
        getName: getName,
        getSectionModel: getSectionModel,
        getItemsProvider: getItemsProvider,
        getToolbarItems: getToolbarItems
    });
}]);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/filemanager/sources/diyfmsourcekeyvisuals.js
 ** module id = 947
 ** module chunks = 0
 **/